import { IconNames, l } from '@manychat/manyui'

import { AiAutomationRoute } from 'apps/aiAutomation/pages/routeItems'
import { typedRouting } from 'utils/router'

interface AiAutomationNavigationItem {
  route: AiAutomationRoute
  icon: IconNames
  label: string
  badge?: 'new'
  to: () => string
}

export const AI_AUTOMATION_NAVIGATION_CONFIG: AiAutomationNavigationItem[] = [
  {
    route: 'overview',
    icon: 'Analytics',
    label: l.translate('Overview'),
    to: () => typedRouting.linkBuilder.aiOverview(),
  },
  {
    route: 'training',
    icon: 'AiKnowledge',
    label: l.translate('Knowledge'),
    to: () => typedRouting.linkBuilder.aiTraining(),
  },
  {
    route: 'behavior',
    icon: 'Bot',
    label: l.translate('Behavior'),
    badge: 'new',
    to: () => typedRouting.linkBuilder.aiBehavior(),
  },
  {
    route: 'skills',
    icon: 'Publish',
    label: l.translate('Skills'),
    to: () => typedRouting.linkBuilder.aiSkills(),
  },
]
